import React, { memo, useEffect } from 'react';
import styles from './Confirmation.module.css';
import Step from '../Step/Step';
import { StepType } from '../../../state/types';
import { useState } from '../../../state/store';
import FormContainer from '../../FormContainer/FormContainer';

const Confirmation: React.FC = memo(() => {
  const { dispatch } = useState();
  // Get new recaptcha Key on successful form submit
  useEffect(() => {
    dispatch('recaptchaKey');
  }, [dispatch]);

  return (
    <Step stepToShow={StepType.Confirmation} stepBack={StepType.Details} isValid={true}>
      <div className={styles.Confirmation} data-testid="Confirmation">
        <div className="w-full bg-gray-100 rounded">
          <FormContainer header={'Thank you'}>
            <p className="pb-3 leading-5 text-justify">
              Your trade-in request has now been submitted and will be processed within 5 business days.
            </p>
            <p className="pb-3 leading-5 text-justify">
              Once we process this trade-in request you will receive an email from the MacroEV team with full
              instructions and next steps.
            </p>
            <p className="pb-3 leading-5 text-justify">
              As part of this process we will also send you a prepaid envelope so that you may return your old trade-in
              device to us.
            </p>
            <p className="pb-3">&nbsp;</p>
            <p className="pb-1">Thank you,</p>
            <p className="pb-1">MacroEV Support Team</p>
          </FormContainer>
        </div>
      </div>
    </Step>
  );
});

export default Confirmation;
